/** Parse deal value from borrowAmount or extra3 (explicit deal value). */
export const getDealValue = (lead = {}) => {
  const raw = lead.borrowAmount || lead.extra3 || lead.deal_value || "";
  if (!raw) return 0;
  const num = Number(String(raw).replace(/[^0-9.]/g, ""));
  return Number.isFinite(num) ? num : 0;
};

export const formatINRShort = (amount) => {
  if (!amount) return null;
  if (amount >= 10000000) return `₹${(amount / 10000000).toFixed(2)} Cr`;
  if (amount >= 100000) return `₹${(amount / 100000).toFixed(2)} L`;
  if (amount >= 1000) return `₹${(amount / 1000).toFixed(1)} K`;
  return `₹${Math.round(amount)}`;
};

export const sumPipelineValue = (leads = []) =>
  leads.reduce((sum, lead) => sum + getDealValue(lead), 0);

const CLOSED_STAGES = new Set(["converted", "not interested", "cancelled"]);

/** Open pipeline = leads not in closed/lost stages and not archived. */
export const getOpenPipelineLeads = (leads = []) =>
  leads.filter((lead) => {
    if (lead.archieve === true || lead.archieve === "true") return false;
    const stage = String(lead.extra || "").toLowerCase();
    return !CLOSED_STAGES.has(stage);
  });

export default getDealValue;
